const Header = () => {
  if (window.matchMedia('(max-width: 1024px)').matches) {
    const toggleMenu = document.querySelectorAll('.toggle-menu')

    toggleMenu.forEach(function (btn) {
      btn.addEventListener('click', function (even) {
        document.querySelector('.main-menu-block').classList.toggle('active')
        btn.classList.toggle('active')
        document.querySelector('body').classList.toggle('block')
        document.querySelector('body').classList.toggle('menu')
        document.querySelector('html').classList.toggle('block')
      })
    })

    const toggleSubmenu = document.querySelectorAll('.menu-item-has-children')

    toggleSubmenu.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.querySelector('.sub-menu-wrap').classList.toggle('active')
      })
    })

    const closeMenuSubmenu = document.querySelectorAll(
      '.menu-item-has-children .close'
    )

    closeMenuSubmenu.forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelector('.main-menu-block').classList.remove('active')
        document
          .querySelector('.sub-menu-wrap.active')
          .classList.remove('active')
        btn.classList.remove('active')
        document.querySelector('.toggle-menu.active').classList.remove('active')
      })
    })
  }

  const toggleAccessibility = document.querySelectorAll('.toggle-accessibility')

  toggleAccessibility.forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.querySelector('.options').classList.toggle('active')
      btn.classList.toggle('active')
    })
  })

  const toggleLanguage = document.querySelectorAll('.toggle-language')
  toggleLanguage.forEach((btn) => {
    btn.addEventListener('click', (btn) => {
      btn.target.querySelector('.options').classList.toggle('active')
      btn.target.classList.toggle('active')
    })
  })

  // ## Animations
  const header = document.querySelector('.home .header-main')

  let bodyScroll = false;

  const checkPageTop = () => {
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop
    if (scrollPosition > 80) {
      document.body.classList.add('scroll')
      bodyScroll = true;
    } else {
      document.body.classList.remove('scroll')
      bodyScroll = false;
    }
  }

  window.addEventListener('scroll', checkPageTop)

  const elementAnimate = document.querySelectorAll('.anmt-fade-up')

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated')
      }
    })
  }

  const options = { rootMargin: '-100px' }
  const myObserver = new IntersectionObserver(callback, options)

  elementAnimate.forEach((element) => {
    myObserver.observe(element)
  })

  const toggleSearch = document.querySelectorAll('.toggle-search')
  toggleSearch.forEach(function (btn) {
    btn.addEventListener('click', function () {
      document
        .querySelector("[data-component='search-modal']")
        .classList.toggle('active')
      btn.classList.toggle('active')
    })
  })

  if(document.querySelector('.home .header-main')){
    document.querySelector('.home .header-main').addEventListener("mouseenter", function () {
      if(!bodyScroll){
        document.body.classList.add('scroll')
      }
    })
  
    document.querySelector('.home .header-main').addEventListener("mouseleave", function () {
      if(!bodyScroll){
        document.body.classList.remove('scroll')
      }
    })
  }

}

export default Header
